export const dynamicEfnOakMessage = () => {
	const country = localStorage.getItem("currentuser-country") || "Deutschland";
	if (country.includes("Deutschland")) {
		return "Fortbildungsnummer (EFN)";
	} else if (country.includes("Oesterreich")) {
		return "Österreichische Ärztekammer-Nummer (ÖÄK-Arztnummer)";
	} else {
		return "";
	}
};
